import { asDashboard } from 'adapter/out/client/dashboard/mappers/dashboard';
import { left, right } from 'fp-ts/lib/Either';

export const callbackParseDashboardResponse = (response: Response) =>
    response.ok
        ? response
              .json()
              .then(asDashboard)
              .then(right)
              .catch(() => left({ error: new Error(), status: 500 }))
        : left({ error: new Error(), status: response.status });
